module.exports = __webpack_public_path__ + "static/img/andres-y-asociados-1.fec43d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/andres-y-asociados-1.jpg
// module id = KPAZ
// module chunks = 1